import api from './api';

export const listarClasses = async () => {
  try {
    console.log('Iniciando requisição para listar classes');
    const response = await api.get('/classes');
    console.log('Resposta do endpoint /classes:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao listar classes:', error);
    throw error;
  }
};

export const obterClasse = async (id) => {
  const response = await api.get(`/classes/${id}`);
  return response.data;
};

export const criarClasse = async (classeData) => {
  const response = await api.post('/classes', classeData);
  return response.data;
};

export const atualizarClasse = async (id, classeData) => {
  const response = await api.put(`/classes/${id}`, classeData);
  return response.data;
};

export const excluirClasse = async (id) => {
  const response = await api.delete(`/classes/${id}`);
  return response.data;
};

export const listarClassesPorCurso = async (cursoId) => {
  const response = await api.get(`/classes/curso/${cursoId}`);
  return response.data;
};